// src/components/Contact.js
import React from 'react';
import '../Contact.css'; // Import the CSS file for Contact

const Contact = () => {
  return (
    <div className="contact-container">
      <h1><a href="mailto:info@ikelosgroup.com">Email us</a></h1>
    </div>
  );
};

export default Contact;
